import { httpRequest } from '../../shared/lib/utils/httpClient';

export interface WaitingService {
  consultId: number;
  sessionId: string;
  patientName: string;
  patientFirstName: string;
  patientLastName: string;
  dob: string;
  createdOn: string;
  modifiedOn: string;
  status: string;
  waitEndTime: string;
  unreadMessageCount: number;
  isHidePhiAfterCompletion: boolean;
}

export interface ConsultStatusResponce {
  status: string;
  consultId: number;
  meetingId: string;
  isWaitingRoom: boolean;
  isErrorPage: boolean;
  errorType: 'abandoned' | 'missed_call';
  isParticipantLeftCall?: boolean;
  isFacilityChanged: boolean;
}

export interface HeartBeatResponse {
  code: string;
  status: string;
  message: string;
}

export const waitingRoomDetails = async (
  consultId: number,
  userId: number
): Promise<WaitingService> => {
  const response = await httpRequest<WaitingService>({
    method: 'GET',
    url: `/facility/facility-user/${consultId}/waiting-room`,
    withCredentials: true,
    headers: {
      userId: userId?.toString(),
    },
  });
  return response;
};

export const updateConsultStatus = async (
  consultId: number,
  userId: number = 0
): Promise<ConsultStatusResponce> => {
  const response = await httpRequest<ConsultStatusResponce>({
    method: 'GET',
    url: `/facility/facility-user/${consultId}/status`,
    withCredentials: true,
    ...(userId > 0 && {
      headers: {
        userId: userId.toString(),
      },
    }),
  });
  return response;
};

export const CallHeartBeatAPI = async (
  consultId: number,
  portalType: string,
  userId: number
): Promise<HeartBeatResponse> => {
  const response = await httpRequest<HeartBeatResponse>({
    method: 'POST',
    url: `/integration/consult/${consultId}/heartbeat`,
    apiBaseType: 'INTEGRATION',
    headers: {
      portalType: portalType,
      userId: userId.toString(),
    },
  });
  return response;
};

export const DeleteHeartBeatAPI = async (
  consultId: number,
  portalType: string,
  userId: number
): Promise<HeartBeatResponse> => {
  const response = await httpRequest<HeartBeatResponse>({
    method: 'DELETE',
    url: `/integration/consult/${consultId}/heartbeat`,
    apiBaseType: 'INTEGRATION',
    headers: {
      portalType: portalType,
      userId: userId.toString(),
    },
  });
  return response;
};

export interface PutConsultOnHoldResponse {
  code: string;
  status: string;
  message: string;
}

export const PutConsultOnHold = async (
  consultId: number,
  userId: number
): Promise<PutConsultOnHoldResponse> => {
  const response = await httpRequest<PutConsultOnHoldResponse>({
    method: 'PUT',
    url: `/facility/case-manager/${consultId}/on-hold`,
    withCredentials: true,
    headers: {
      userId: userId.toString(),
    },
  });
  return response;
};
